var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoBox"},[_c('div',{staticClass:"logoMain"},[_c('img',{staticClass:"logoImg",attrs:{"src":require("assets/img/other/register/7seasLogo.png")}})])])
}]

export { render, staticRenderFns }